import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { FileTextIcon } from 'lucide-react'
import { useCalculator } from '@/contexts/CalculatorContext'

export function ContractsTable() {
  const { contracts, getContractsBonus } = useCalculator()
  const currentBonus = getContractsBonus(contracts)
  
  return (
    <Card className="w-full">
      <CardHeader>
        <div className="flex items-center gap-2">
          <FileTextIcon className="w-5 h-5 text-primary" />
          <div>
            <CardTitle>3. složka</CardTitle>
            <p className="text-sm text-muted-foreground mt-1">
              Počet nových aktivních rámcových smluv
            </p>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {[
            { count: '1 smlouva', bonus: '15 000 Kč', bonusValue: 15000 },
            { count: '2 smlouvy', bonus: '20 000 Kč', bonusValue: 20000 },
            { count: '3 smlouvy', bonus: '25 000 Kč', bonusValue: 25000 },
            { count: '4 a více', bonus: '30 000 Kč', bonusValue: 30000 },
          ].map((item, index) => {
            // Compare by bonus value instead of formatted string
            const isHighlighted = currentBonus > 0 && currentBonus === item.bonusValue
            return (
              <div
                key={index}
                className={`flex justify-between py-2 border-b last:border-0 ${
                  isHighlighted 
                    ? 'bg-green-50 px-2 rounded-md font-medium' 
                    : ''
                }`}
              >
                <span className={`${
                  isHighlighted 
                    ? 'text-green-700' 
                    : 'text-muted-foreground'
                }`}>
                  {item.count}
                </span>
                <span className={`${
                  isHighlighted 
                    ? 'text-green-700' 
                    : 'font-medium'
                }`}>
                  {item.bonus}
                </span>
              </div>
            )
          })}
        </div>
      </CardContent>
    </Card>
  )
} 